import Helper from "../../../helpers/helpers";

const fb = require('../../../config/firebase.js')
import { fbFunctions } from "@/config/firebase";
import { i18n } from "../../../i18n";

// https://tahazsh.com/vuebyte-reset-module-state
const getDefaultState = () => {
    return {
        activeTab: 'overview',
        notifications: {},
        notificationsCount: 0,
        statsScoreByDay: [
            0,0,0,0,0,0
        ],
        statsLoaded: false,
        userInformationsPage: {
            uploadPercentageAvatar: 0,
            uploadPercentageCover: 0,
            uploadPercentageCv: 0,
        },
        userProfile: {},
        userProfileLoaded: false,
    }
}

const state = () => getDefaultState()

const getters = {}

const actions = {
    fetchNotifications({ commit, state }, payload) {
        fb.usersCollection
            .doc(payload.userId)
            .collection('user_notifications')
            .where('local_user_id', '==', payload.userId)
            .orderBy("date", "desc")
            .limit(6)
            .get()
            .then((docSnaps) => {
                commit('setResetNotifications');
                docSnaps.forEach(function (doc) {
                    commit('setNotifications', {
                        'id': doc.id,
                        'data': doc.data()
                    })
                    fb.usersCollection
                        .doc(doc.data().remote_user_id)
                        .get()
                        .then((user) => {
                            commit('setNotificationsUserInfos', {
                                'id': doc.id,
                                'nickname': user.data().nickname
                            })
                            commit('setNotificationsCount', state.notificationsCount += 1)
                        })
                })
            });
    },
    fetchGraphData({ commit, state }, payload) {
        for (let i = 0; i < 5; i++) {
            fb.usersCollection
                .doc(payload.userId)
                .collection("user_statistics")
                .doc(Helper.retrieveDate(i).toString())
                .get()
                .then(function(doc) {
                    if (doc.exists) {
                        commit('setScoreByDay', {
                            'day': i,
                            'points': doc.data().points
                        })
                    }
                    commit('setStatsLoaded', true);
                })
                .catch((e) => console.log("Error getting document stats - :", e));
        }
    },
    fetchUserProfile({ commit, state }, payload) {
        fb.usersCollection
            .doc(payload.userId)
            .get()
            .then(function (doc) {
                commit('setUserProfile', doc.data())
                commit('setUserProfileLoaded', true)
            })
            .catch((e) => console.log("Error getting document - user profile:", e));
    },
    saveUserInformations({ commit, state }) {
        let saveProfileInfos = fbFunctions.httpsCallable('api');
        Swal.fire(
            i18n.t("dashboard.partials.informations.save_in_progress_title"),
            i18n.t("dashboard.partials.informations.save_in_progress_content"),
            "warning"
        );
        saveProfileInfos({
            type: 'webUpdateProfileInformations',
            parameters: {
                about: state.userProfile.about,
                nickname: state.userProfile.nickname,
                phone: state.userProfile.phone,
                isThemeDark: state.userProfile.preferences.preferences_dark_theme_enabled,
                isEmailPublic: state.userProfile.preferences.preferences_display_publicly_email,
                hashtags: {
                    'number1': state.userProfile.hashtags['number1'],
                    'number2': state.userProfile.hashtags['number2'],
                    'number3': state.userProfile.hashtags['number3'],
                }
            }
        })
        .then(function(result) {
            if(result.data === "SUCCESS_PROFILE_UPDATE") {
                swal.fire(
                    i18n.t("dashboard.partials.informations.success_profile_update_title"),
                    i18n.t("dashboard.partials.informations.success_profile_update_content"),
                    "success"
                )
            }
            else {
                swal.fire(
                    i18n.t("dashboard.partials.informations.error_profile_update_title"),
                    i18n.t("dashboard.partials.informations.error_profile_update_content"),
                    "error"
                )
            }
        })
        .catch((e) => {
            console.log("FC RESULT ERROR " + e);
            swal.fire(
                i18n.t("dashboard.partials.informations.error_profile_update_title"),
                i18n.t("dashboard.partials.informations.error_profile_update_content"),
                "error"
            )
        });
    },
    onAvatarUpload({ commit, state }, payload) {
        if(location.hostname === "localhost") {
            swal.fire(
                i18n.t("global.not_available_in_test_title"),
                i18n.t("global.not_available_in_test_content"),
                "error"
            );
        }
        else {
            Swal.fire(
                i18n.t("dashboard.partials.informations.upload_in_progress_title"),
                i18n.t("dashboard.partials.informations.upload_in_progress_content"),
                "warning"
            );

            let fileSize = payload.image.size / 1024 / 1024;

            if(fileSize > 10) {
                swal.fire(
                    i18n.t("dashboard.partials.informations.upload_error_file_too_big_title"),
                    i18n.t("dashboard.partials.informations.upload_error_file_too_big_content"),
                    "error"
                );
            }
            else {
                const storageRef = fb.storage.ref('users/' + payload.userId + '/avatar/' + payload.userId + '.jpg').put(payload.image);
                storageRef.on(`state_changed`,snapshot=> {
                    commit('setAvatarUploadPercentage', (snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                },
                error => { console.log(error.message) },
                () => {
                    commit('setAvatarUploadPercentage', 100);
                    storageRef.snapshot.ref.getDownloadURL().then((url)=>{
                        let saveProfileInfos = fbFunctions.httpsCallable('api');
                        saveProfileInfos({
                            type: 'updateUserSingleRow',
                            parameters: {
                                'rowName': 'avatar',
                                'rowValue': url,
                            }
                        }).then(function(result) {
                            console.log(result.data)
                            swal.fire(
                                i18n.t("dashboard.partials.informations.upload_success_title"),
                                i18n.t("dashboard.partials.informations.upload_success_content"),
                                "success"
                            );
                            commit('setUserField', {
                                fieldToEdit: 'avatar',
                                fieldToEditValue: url,
                            })
                        }).catch(function(e) {
                            swal.fire(
                                i18n.t("dashboard.partials.informations.upload_error_title"),
                                i18n.t("dashboard.partials.informations.upload_error_content"),
                                "success"
                            );
                        });
                    });
                });
            }
        }
    },
    onCoverUpload({ commit, state }, payload) {
        if(location.hostname === "localhost") {
            swal.fire(
                i18n.t("global.not_available_in_test_title"),
                i18n.t("global.not_available_in_test_content"),
                "error"
            );
        }
        else {
            Swal.fire(
                i18n.t("dashboard.partials.informations.upload_in_progress_title"),
                i18n.t("dashboard.partials.informations.upload_in_progress_content"),
                "warning"
            );

            let fileSize = payload.image.size / 1024 / 1024;

            if(fileSize > 10) {
                swal.fire(
                    i18n.t("dashboard.partials.informations.upload_error_file_too_big_title"),
                    i18n.t("dashboard.partials.informations.upload_error_file_too_big_content"),
                    "error"
                );
            }
            else {
                const storageRef = fb.storage.ref('users/' + payload.userId + '/cover/' + payload.userId + '.jpg').put(payload.image);
                storageRef.on(`state_changed`, snapshot=> {
                    commit('setCoverUploadPercentage', (snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                },
                error => { console.log(error.message) },
                () => {
                    commit('setCoverUploadPercentage', 100);
                    storageRef.snapshot.ref.getDownloadURL().then((url)=> {
                        let saveProfileInfos = fbFunctions.httpsCallable('api');
                        saveProfileInfos({
                            type: 'updateUserSingleRow',
                            parameters: {
                                'rowName': 'cover',
                                'rowValue': url,
                            }
                        }).then(function(result) {
                            console.log(result.data)
                            swal.fire(
                                i18n.t("dashboard.partials.informations.upload_success_title"),
                                i18n.t("dashboard.partials.informations.upload_success_content"),
                                "success"
                            );
                            commit('setUserField', {
                                fieldToEdit: 'cover',
                                fieldToEditValue: url,
                            })
                        }).catch(function(e) {
                            swal.fire(
                                i18n.t("dashboard.partials.informations.upload_error_title"),
                                i18n.t("dashboard.partials.informations.upload_error_content"),
                                "success"
                            );
                        });
                    });
                });
            }
        }
    },
    onCvUpload({ commit, state }, payload) {
        if(location.hostname === "localhost") {
            swal.fire(
                i18n.t("global.not_available_in_test_title"),
                i18n.t("global.not_available_in_test_content"),
                "error"
            );
        }
        else {
            Swal.fire(
                i18n.t("dashboard.partials.informations.upload_in_progress_title"),
                i18n.t("dashboard.partials.informations.upload_in_progress_content"),
                "warning"
            );

            let fileSize = payload.cvFile.size / 1024 / 1024;

            if(fileSize > 10) {
                swal.fire(
                    i18n.t("dashboard.partials.informations.upload_error_file_too_big_title"),
                    i18n.t("dashboard.partials.informations.upload_error_file_too_big_content"),
                    "error"
                );
            }
            else {
                const storageRef = fb.storage.ref('users/' + payload.userId + '/curriculum_vitae/' + payload.userId + '.pdf').put(payload.cvFile);
                storageRef.on(`state_changed`, snapshot=> {
                    commit('setCvUploadPercentage', (snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                },
                error => { console.log(error.message) },
                () => {
                    commit('setCvUploadPercentage', 100);
                    storageRef.snapshot.ref.getDownloadURL().then((url)=> {
                        let saveProfileInfos = fbFunctions.httpsCallable('api');
                        saveProfileInfos({
                            type: 'updateUserSingleRow',
                            parameters: {
                                'rowName': 'curriculum_vitae',
                                'rowValue': url,
                            }
                        }).then(function(result) {
                            console.log(result.data)
                            swal.fire(
                                i18n.t("dashboard.partials.informations.upload_cv_success_title"),
                                i18n.t("dashboard.partials.informations.upload_cv_success_content"),
                                "success"
                            );
                            commit('setUserField', {
                                fieldToEdit: 'curriculum_vitae',
                                fieldToEditValue: url,
                            })
                        }).catch(function(e) {
                            swal.fire(
                                i18n.t("dashboard.partials.informations.upload_error_title"),
                                i18n.t("dashboard.partials.informations.upload_error_content"),
                                "success"
                            );
                        });
                    });
                });
            }
        }
    },
    deleteUserCv({ commit, state }, payload) {
        Swal.fire(
            i18n.t("dashboard.partials.informations.delete_cv_in_progress_title"),
            i18n.t("dashboard.partials.informations.delete_cv_in_progress_content"),
            "warning"
        );

        fb.storage.ref('users/' + payload.userId + '/curriculum_vitae/' + payload.userId + '.pdf').delete()
            .then((result) => {
                let saveProfileInfos = fbFunctions.httpsCallable('api');
                saveProfileInfos({
                    type: 'updateUserSingleRow',
                    parameters: {
                        'rowName': 'curriculum_vitae',
                        'rowValue': null,
                    }
                }).then(function(result) {
                    swal.fire(
                        i18n.t("dashboard.partials.informations.delete_cv_success_title"),
                        i18n.t("dashboard.partials.informations.delete_cv_success_content"),
                        "success"
                    );
                    commit('setUserField', {
                        fieldToEdit: 'curriculum_vitae',
                        fieldToEditValue: null,
                    })
                }).catch(function(e) {
                    swal.fire(
                        i18n.t("dashboard.partials.informations.delete_cv_error_title"),
                        i18n.t("dashboard.partials.informations.delete_cv_error_content"),
                        "success"
                    );
                });
            }).catch(function(e) {
                swal.fire(
                    i18n.t("dashboard.partials.informations.delete_cv_error_title"),
                    i18n.t("dashboard.partials.informations.delete_cv_error_content"),
                    "success"
                );
            });
    },
    saveUserNetworks ({ commit, state }) {
        let saveProfileInfos = fbFunctions.httpsCallable('api');
        Swal.fire(
            i18n.t("dashboard.partials.informations.save_in_progress_title"),
            i18n.t("dashboard.partials.informations.save_in_progress_content"),
            "warning"
        );
        saveProfileInfos({
            type: 'webUpdateUserNetworks',
            parameters: {
                'networks': {
                    'network_facebook': state.userProfile.networks.network_facebook,
                    'network_twitter': state.userProfile.networks.network_twitter,
                    'network_snapchat': state.userProfile.networks.network_snapchat,
                    'network_instagram': state.userProfile.networks.network_instagram,
                    'network_twitch': state.userProfile.networks.network_twitch,
                    'network_tiktok': state.userProfile.networks.network_tiktok,
                    'network_vimeo': state.userProfile.networks.network_vimeo,
                    'network_youtube': state.userProfile.networks.network_youtube,
                    'network_github': state.userProfile.networks.network_github,
                    'network_linkedin': state.userProfile.networks.network_linkedin,
                    'network_website': state.userProfile.networks.network_website,
                    'network_paypal': state.userProfile.networks.network_paypal,
                    'network_xboxlive': state.userProfile.networks.network_xboxlive,
                    'network_psn': state.userProfile.networks.network_psn,
                    'network_steam': state.userProfile.networks.network_steam,
                    'network_origin': state.userProfile.networks.network_origin,
                    'network_battlenet': state.userProfile.networks.network_battlenet,
                    'network_uplay': state.userProfile.networks.network_uplay,
                    'network_epicgames': state.userProfile.networks.network_epicgames,
                    'network_spotify': state.userProfile.networks.network_spotify,
                    'network_soundcloud': state.userProfile.networks.network_soundcloud,
                    'network_deezer': state.userProfile.networks.network_deezer,
                    'network_applemusic': state.userProfile.networks.network_applemusic,
                    'network_believemusic': state.userProfile.networks.network_believemusic,
                    'network_skype': state.userProfile.networks.network_skype,
                    'network_teams': state.userProfile.networks.network_teams,
                    'network_discord': state.userProfile.networks.network_discord,
                    'network_deviantart': state.userProfile.networks.network_deviantart,
                    'network_pinterest': state.userProfile.networks.network_pinterest,
                    'network_dribbble': state.userProfile.networks.network_dribbble,
                    'network_tipeee': state.userProfile.networks.network_tipeee,
                    'network_patreon': state.userProfile.networks.network_patreon,
                    'network_kickstarter': state.userProfile.networks.network_kickstarter,
                    'network_gofundme': state.userProfile.networks.network_gofundme,
                    'network_leetchi': state.userProfile.networks.network_leetchi,
                    'network_utip': state.userProfile.networks.network_utip,
                    'network_ebay': state.userProfile.networks.network_ebay,
                    'network_leboncoin': state.userProfile.networks.network_leboncoin,
                    'network_vinted': state.userProfile.networks.network_vinted,
                    'network_onlyfans': state.userProfile.networks.network_onlyfans,
                    'network_mym': state.userProfile.networks.network_mym,
                },
            }
        })
        .then(function(result) {
            if(result.data === "SUCCESS_NETWORKS_UPDATE") {
                swal.fire(
                    i18n.t("dashboard.partials.networks.success_networks_update_title"),
                    i18n.t("dashboard.partials.networks.success_networks_update_content"),
                    "success"
                )
            } else {
                swal.fire(
                    i18n.t("dashboard.partials.networks.error_networks_update_title"),
                    i18n.t("dashboard.partials.networks.error_networks_update_content"),
                    "error"
                )
            }
        })
        .catch((e) => {
            swal.fire(
                i18n.t("dashboard.partials.networks.error_networks_update_title"),
                i18n.t("dashboard.partials.networks.error_networks_update_content"),
                "error"
            )
        });
    },
}

const mutations = {
    setActiveTab(state, val) {
        state.activeTab = val;
    },
    setNotifications(state, val) {
        state.notifications[val.id] = val.data;
    },
    setNotificationsUserInfos(state, val) {
      state.notifications[val.id].nickname = val.nickname;
    },
    setNotificationsCount(state, val) {
        state.notificationsCount = val;
    },
    setScoreByDay(state, val) {
        state.statsScoreByDay[val.day] = val.points;
    },
    setStatsLoaded(state, val) {
        state.statsLoaded = val;
    },
    setUserProfile(state, val) {
        state.userProfile = val;
    },
    setUserProfileLoaded(state, val) {
        state.userProfileLoaded = val;
    },
    setUserField(state, val) {
        state.userProfile[val.fieldToEdit] = val.fieldToEditValue;
    },
    setUserPreferences(state, val) {
        state.userProfile.preferences[val.fieldToEdit] = val.fieldToEditValue;
    },
    setUserHashtags(state, val) {
        state.userProfile.hashtags[val.hashtagToEdit] = val.hashtagToEditValue;
    },
    setUserNetworks(state, val) {
        state.userProfile.networks[val.networkToEdit] = val.networkToEditValue;
    },
    setAvatarUploadPercentage(state, val) {
        state.uploadPercentageAvatar = val;
    },
    setCoverUploadPercentage(state, val) {
        state.uploadPercentageCover = val;
    },
    setCvUploadPercentage(state, val) {
        state.uploadPercentageCv = val;
    },
    setResetNotifications(state, val) {
        state.notifications = {};
        state.notificationsCount = 0;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/stores/modules/pages/dashboard.js